import React from "react";
import Reveal from "./Reveal";

const CARDS = [
  {
    code: "ARENA SPONSORSHIP",
    title: "Arena Sponsorship",
    forWhom: "Companies wanting first-access hiring rights to top AI builders.",
    bullets: [
      "Recruiter access to Arena cohorts",
      "Sponsor visibility at regional editions",
      "Judging panel seats at the Global Finale",
    ],
    cta: "Sponsor an edition",
  },
  {
    code: "DIRECT HIRING",
    title: "Direct Hiring",
    forWhom: "Companies hiring AI talent now.",
    bullets: [
      "Post roles to a pool of certified AI practitioners",
      "Smart talent matching by skill and tier",
      "Branded talent pool builder",
    ],
    cta: "Post a role",
  },
  {
    code: "CUSTOM TALENT BUILDING",
    title: "Custom Talent Building",
    forWhom: "Companies wanting AI talent trained for their stack.",
    bullets: [
      "Custom training cohort scoped to your tech stack",
      "Pre-placement assessments and projects",
      "Hire-from-cohort rights with guaranteed placements",
    ],
    cta: "Build a custom cohort",
  },
];

export default function TalentAcquisition() {
  return (
    <section
      id="talent"
      className="py-10 md:py-14 border-t hairline"
      data-testid="talent-section"
    >
      <div className="container-edge">
        <Reveal>
          <p className="section-number">06 — FOR TALENT ACQUISITION</p>
        </Reveal>

        <div className="mt-5 grid grid-cols-1 lg:grid-cols-12 gap-8">
          <div className="lg:col-span-7">
            <Reveal>
              <h2
                className="font-display text-[40px] sm:text-[52px] lg:text-[68px] leading-[0.95] tracking-tight"
                style={{ fontWeight: 500 }}
              >
                Hiring AI talent? <em className="italic grad-brand-text" style={{ fontWeight: 500 }}>We are the pipeline.</em>
              </h2>
            </Reveal>
          </div>
          <div className="lg:col-span-5 flex items-end">
            <Reveal delay={120}>
              <p
                className="text-[15px] md:text-[17px] leading-relaxed max-w-[720px]"
                style={{ color: "var(--ink-secondary)" }}
              >
                The AI talent shortage is real. We solve it from the source — by certifying
                practitioners through The Practitioner Method™, putting them through real builds
                in the AI Innovation Arena, and connecting them to companies hiring AI talent.
                Three ways to engage with us as a talent buyer.
              </p>
            </Reveal>
          </div>
        </div>

        <div className="mt-10 grid grid-cols-1 md:grid-cols-3 gap-5">
          {CARDS.map((c, i) => (
            <Reveal key={c.code} delay={i * 80}>
              <article
                className="card-edge h-full p-6 lg:p-7 flex flex-col"
                data-testid={`talent-card-${i + 1}`}
              >
                <p className="mono-label-gold">CARD {String(i + 1).padStart(2, "0")} · {c.code}</p>
                <h3
                  className="mt-3 font-display text-[22px] tracking-tight leading-tight"
                  style={{ fontWeight: 500 }}
                >
                  {c.title}
                </h3>
                <p
                  className="mt-3 italic text-[13.5px] leading-relaxed"
                  style={{ color: "var(--ink-secondary)" }}
                >
                  <span style={{ color: "var(--ink-tertiary)" }} className="font-mono not-italic">For: </span>
                  {c.forWhom}
                </p>

                <div className="mt-5">
                  <p className="mono-label mb-2">YOU GET</p>
                  <ul className="space-y-1.5">
                    {c.bullets.map((b) => (
                      <li
                        key={b}
                        className="text-[13px] leading-relaxed pl-4 relative"
                        style={{ color: "var(--ink-secondary)" }}
                      >
                        <span
                          className="absolute left-0 top-[9px] w-2 h-px"
                          style={{ background: "var(--accent-gold)" }}
                        />
                        {b}
                      </li>
                    ))}
                  </ul>
                </div>

                <a
                  href="#enquiry"
                  className="mt-auto pt-6 text-[14px] link-underline text-ink font-medium"
                  data-testid={`talent-cta-${i + 1}`}
                  onClick={() => {
                    try {
                      window.dispatchEvent(
                        new CustomEvent("enquiry:prefill", {
                          detail: { interest: "talent_hiring", audience: "corporate" },
                        })
                      );
                    } catch (_) {}
                  }}
                >
                  {c.cta} →
                </a>
              </article>
            </Reveal>
          ))}
        </div>

        <Reveal delay={260}>
          <p
            className="mt-10 font-display italic text-[20px] md:text-[26px] max-w-[720px]"
            style={{ color: "var(--ink-secondary)", fontWeight: 400 }}
          >
            "We don't recruit from the market. We build the market."
          </p>
        </Reveal>
      </div>
    </section>
  );
}
